import * as fromRoot from "#core/router-store";
import { createSelector } from "@ngrx/store";
import { PPAssignment as Assignment } from "cli-types";
import * as fromFeature from "../reducers";
import * as fromAssignments from "../reducers/assignments.reducer";

// Now, one level down from 'assignmentsModule' in our state tree
// Assignments state
// In createSelector, we essential build the path to the state we want
// getAssignmentsModuleState = top level of state tree: assignmentsModule
export const getAssignmentsState = createSelector(
    fromFeature.getStudentCoursesModuleState,
    (state: fromFeature.StudentCoursesState) => state?.assignments
);

// these select individual properties on a Assignment State (data, loading, loaded)
// using the entities, this returns a data object (used for high-performance reading, updating & removing)
export const getStudentAssignmentsEntities = createSelector(
    getAssignmentsState,
    fromAssignments.getStudentAssignmentsEntities
);

// get individual assignment
export const getSelectedAssignment = createSelector(
    getAssignmentsState,
    (state): Assignment | null => {
        return state?.selectedAssignment;
    }
);

// get individual teacher-class
export const getAssignmentByRoute = createSelector(
    // teacher-classes state (list of all teacher-classes)
    getAssignmentsState,
    // url state (current url)
    fromRoot.getRouterState,
    // returns the teacher-class based off url param
    (state, router): Assignment | null => {
        if (router) {
            const assignmentID = parseInt(router.state.params.assignmentID, 10);
            const activityID = parseInt(
                router.state.params.compositeTaskAssignmentID,
                10
            );

            let assignment = state.entities.get(assignmentID);
            if (
                !assignment &&
                state.selectedAssignment &&
                state.selectedAssignment.relatedCompositeAssignments &&
                state.selectedAssignment.relatedCompositeAssignments.length > 0
            ) {
                // Check the related assignments on the selected assignment.
                assignment =
                    state.selectedAssignment.relatedCompositeAssignments.find(
                        (a) => a.assignmentID === assignmentID
                    );
            }
            if (assignment) {
                return assignment;
            }
        }
        return null;
    }
);

export const getAllStudentAssignments = createSelector(
    getStudentAssignmentsEntities,
    // assignments state (list of all assignments)
    (entities) => {
        return Array.from(entities.values());
    }
);

export const getStudentAssignmentsLoaded = createSelector(
    getAssignmentsState,
    fromAssignments.getStudentAssignmentsLoaded
);

export const getAssignmentsLoading = createSelector(
    getAssignmentsState,
    fromAssignments.getStudentAssignmentsLoading
);

export const getRawResponse = createSelector(
    getAssignmentsState,
    fromAssignments.getRawResponse
);

export const getPaginationParams = createSelector(
    getAssignmentsState,
    fromAssignments.getPaginationParams
);

export const getDisplayFilterParams = createSelector(
    getAssignmentsState,
    fromAssignments.getDisplayFilterParams
);

export const getSelectedAssignmentID = createSelector(
    getAssignmentsState,
    fromAssignments.getSelectedAssignmentID
);

export const getSelectedAssignmentActivityID = createSelector(
    getAssignmentsState,
    fromAssignments.getSelectedAssignmentActivityID
);

export const getLaunchedInNewTab = createSelector(
    getAssignmentsState,
    fromAssignments.getLaunchedInNewTab
);
